import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    UPDATE_INTERNAL_BANNER_TEMPLATE_ID,
    UpdateInternalBannerTemplateId
} from '../../../actions/bannersEdit/internal/updateInternalBannerTemplateId';
import {
    AddInternalBannerImage,
    addInternalBannerImageAction
} from '../../../actions/imageEditor/internal/addInternalBannerImage';
import {
    ResetInternalBannerImageUploadError,
    resetInternalBannerImageUploadErrorAction
} from '../../../actions/imageEditor/internal/resetInternalBannerImageUploadError';
import { selectEditedBanner } from '../../../selectors/bannerEdit/banner';
import { selectInternalBannerResources } from '../../../selectors/internalBannerEdit/internalBannerEdit';
import { EpicDeps } from '../../../service/StoreFactory';
import { getBannerWithImage } from '../../../typings/bannersEditState';
import { GdResourceType } from '../../../typings/graphql-grid';
import { InternalTemplateResource } from '../../../typings/internalBanners';
import { State } from '../../../typings/state';

type EpicActions = AddInternalBannerImage | ResetInternalBannerImageUploadError;

const getAddInternalBannerImageActions = (state: State, action: UpdateInternalBannerTemplateId): EpicActions[] => {
    const banner = getBannerWithImage(selectEditedBanner(state, action.bannerId));

    const resources: InternalTemplateResource[] =
        (banner && selectInternalBannerResources(state.editInternalBanners, banner.campaign.id, action.value)) || [];

    return resources.reduce<EpicActions[]>((acc, { id, type, templateId }) => {
        if (type === GdResourceType.IMAGE && templateId === action.value) {
            acc.push(
                addInternalBannerImageAction(action.bannerId, id),
                resetInternalBannerImageUploadErrorAction(action.bannerId, id)
            );
        }

        return acc;
    }, []);
};

export const updateInternalBannerTemplateIdEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(UPDATE_INTERNAL_BANNER_TEMPLATE_ID),
        mergeMap(
            (action: UpdateInternalBannerTemplateId): Observable<EpicActions> => {
                return of(...getAddInternalBannerImageActions(store$.value, action));
            }
        )
    );
};
